module.exports = __webpack_public_path__ + "static/img/one.b21f74f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/13/one.png
// module id = FiBj
// module chunks = 1